var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w-3/4 text-start self-start mb-5 text-base md:text-lg",class:['text-' + _vm.options.color]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }